<template>
    <div>
        <el-card>
            <el-form :inline="true" :model="form">
                <el-form-item>
                    <el-input v-model="form.keyWord" placeholder="请输入关键字"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="request">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="tableData" v-loading='loading' border @selection-change='selectclick'>
                <el-table-column type='index'></el-table-column>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label='名称' prop="title"></el-table-column>
                <el-table-column label="描述" prop="description"></el-table-column>
                <el-table-column label="上传时间" prop="createTime"></el-table-column>
                <el-table-column label="创建人" prop="createUser"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>

        </el-card>
    </div>
</template>

<script>
import services from './addDocument.services'
export default {
    props: {
        id: Number,
        type: String,
        filterCondition:Number
    },
    data() {
        return {
            form:{
                keyWord:"",
                pageSize:10,
                pageIndex:1,
            },
            total:null,
            tableData: [],
            loading: true,
        }
    },
    mounted() {
        if (this.filterCondition){
            this.form = {
                ...this.form,
                status:113
                // filterCondition: this.filterCondition
            }
            this.request()
        } else{
            this.request()
        }

    },
    methods: {
        request() {
            services.docSearch(this.form)
                .then(res => {
                    // console.log(res.list)
                    this.tableData = res.list
                    this.total = res.total
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },

        selectclick(selection) {
            this.$emit('getServes', selection)
        },
        handleSizeChange(val){
            let pages = Math.ceil(this.total / val);
            this.form.pageSize = val;
            if(this.form.pageIndex > pages ){
                this.form.pageIndex  = 1;
            };
            this.request()
        },
        handleCurrentChange(val){
            this.form.pageIndex = val;
            this.request();
        }
        
        
    }
}
</script>

<style>
    .footer {
        margin: 20px 0;
    }
</style>
